import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: '',
  severity: 'success', // 'success' or 'error'
  timestamp: null,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity || 'success';
      state.timestamp = Date.now();
    },
    hideSnackbar: (state) => {
      state.message = '';
      state.timestamp = null;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer; 